import './Square.css'

const Square = ({colored, curr}) => {
    return <div className={`square ${(colored ? 'colored' : '')} ${(curr ? 'curr' : '')}`}></div>;
}

export default Square;